export function getRootUrl(sub: string = "") {
  if (typeof window === "undefined") return "";

  const { protocol, hostname, port } = window.location;
  const rootDomain = process.env.NEXT_PUBLIC_ROOT_DOMAIN;

  // localhost case
  if (hostname.includes("localhost")) {
    if (sub) {
      return `${protocol}//${sub}.localhost:${port}`;
    }

    return `${protocol}//localhost:${port}`;
  }

  // production
  if (sub) {
    return `${protocol}//${sub}.${rootDomain}`;
  }

  return `${protocol}//${rootDomain}`;
}
